export const defaultState = () => {
    return {
        autoStart: false,
        model: null,
        condition: null,
        manufacturer: null,
        id: null,
        timer_start: null,
        timer_end: null,
        aquire: null,
        timeout: null,
        status: 'none',
        beep: true,
        skip: false,
    }
}

const state = defaultState()
export default state
